export interface IErrorItem {
  row: string;
  errorMessage: string;
}

export interface IPropsPublishBundleErrorModal {
  onConFirm?: () => void;
  title?: string;
  errorItems?: IErrorItem[];
  confirmText?: string;
}

const PublishBundleErrorModal = (props: IPropsPublishBundleErrorModal) => {
  const { onConFirm, confirmText, title, errorItems } = props;

  return (
    <>
      <div className="modal modal-open">
        <div className="relative modal-box max-w-[76vw] w-[76vw]">
          <h3 className="text-lg font-bold font-dbh">{title || 'Error Transactions'}</h3>

          <div className="rounded-md mt-12 overflow-auto h-[60vh] scrollbar-hide">
            <table className="table w-full table-zebra font-tt">
              <thead>
                <tr>
                  <th>No</th>
                  <th className="sticky z-50 left-12">Row</th>
                  <th>Error Message</th>
                </tr>
              </thead>
              <tbody>
                {errorItems?.map((errorItem, index) => (
                  <tr key={`${index}-${errorItem.row}`}>
                    <th className="font-normal">{index + 1}</th>
                    <td className="sticky z-50 left-12">{errorItem.row}</td>
                    <td>{errorItem.errorMessage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end w-full pt-24 space-x-4">
            <button className="btn btn-error" onClick={onConFirm}>
              {confirmText || 'OK, I’m noticed'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PublishBundleErrorModal;
